<template>
  <div class="rt-grid">
    <div class="rt-grid__header">
      <h1 class="rt-grid__title" v-if="views && views.length > 0">
        {{ views[0] }}
      </h1>
      <div class="rt-grid__header_right" v-if="showQuickSearch">
        <rt-toolbar v-if="$slots.toolbar">
          <slot name="toolbar"></slot>
        </rt-toolbar>
        <el-input v-if="needSearch" :placeholder="quicksearchPlaceholder" @keyup.enter.native="handleQuickSearch"
          v-model="quickSearch" style="width: 220px;height:34px">
          <el-button slot="append" icon="el-icon-search" @click="handleQuickSearch" type="text"
            style="margin: -10px -19px;height:34px"></el-button>
        </el-input>
        <el-button type="text" @click="handleCollapse" v-if="$slots.more">
          <i :class="iconClass" style="font-size: 10px"></i>
          {{ $t("xpc.search.more") }}
        </el-button>
      </div>
    </div>
    <div id="grid__moresearch" class="rt-grid__moresearch" v-show="$slots.more && showHidden">
      <slot name="more"></slot>
      <el-row :gutter="40" type="flex">
        <el-col v-bind:span="24" style="float: right; text-align: right">
          <!-- <el-button
            plain
            size="small"
            @click="handleReset"
            class="rt-query__reset"
          >
            {{ $tx("重置", "xpc.search.reset") }}</el-button
          > -->
          <!-- <el-button type="primary" size="small" @click="handleSearch">
            {{ $tx("查询", "xpc.search.search") }}</el-button
          > -->

          <el-button plain size="small" @click="handleReset" class="rt-query__reset">
            {{ $t("filter.reset") }}</el-button>
          <el-button type="primary" size="small" @click="handleSearch">
            {{ $t("all.query") }}</el-button>
          <slot v-if="$slots.moretoolbar" name="moretoolbar"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="rt-grid__body">
      <slot></slot>
    </div>
    <div class="rt-grid__footer">
      <el-pagination class="is-border" v-if="showPagination" @size-change="handleSizeChange"
        @current-change="handleIndexChange" :current-page="pageIndex" :page-size="pageSize" :page-sizes="pageSizes"
        :layout="layout" :total="totalRecord"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "RtGrid",
  data() {
    return {
      quickSearch: null,

      moreHeight: 0,
      pageIndex: 1,
      layout: "total, sizes, prev, pager, next, jumper",
      pageSizes: [5, 10, 20, 30, 40, 50],
      initPageIndex: false,
    };
  },
  props: {
    pageSize: {
      type: Number,
      required: false,
      default: 20,
    },
    views: {
      type: Array,
      required: true,
    },
    quicksearchPlaceholder: String,
    showPagination: {
      type: Boolean,
      default: true,
      required: false,
    },
    totalRecord: {
      type: Number,
      required: false,
    },
    headerShow: {
      type: Boolean,
      default: true,
    },
    needSearch: {
      type: Boolean,
      default: true,
    },
    showHidden: {
      type: Boolean,
      default: false,
    },
    showQuickSearch: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    iconClass() {
      return this.showHidden ? "el-icon-arrow-up" : "el-icon-arrow-down";
    },
  },
  created() { },
  mounted() { },
  methods: {
    handleCollapse() {
      this.showHidden = !this.showHidden;
      this.$nextTick(() => {
        var tableHeight = document.body.clientHeight - 270;
        var moreHeight =
          document.getElementById("grid__moresearch").clientHeight;

        this.$store.commit("UPDATE_TABLE_HEIGHT", tableHeight - moreHeight);
      });
    },
    handleReset() {
      this.$emit("reset");
    },
    handleSearch() {
      this.pageIndex = 1;
      this.$emit("search");
    },

    handleQuickSearch() {
      this.pageIndex = 1;
      this.$emit("quick-search");
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.$emit("page-change", this.pageIndex, this.pageSize);
    },
    handleIndexChange(val) {
      this.pageIndex = val;
      this.$emit("page-change", this.pageIndex, this.pageSize);
    },
    initChangePageIndex() {
      this.initPageIndex = true;
    },
    getPageIndex() {
      if (this.initPageIndex) {
        this.initPageIndex = false;
        return 1;
      } else {
        return this.pageIndex;
      }
    },
    getPageSize() {
      return this.pageSize;
    },
    getSearchString() {
      return this.quickSearch;
    },
    setSearchString(quicksearch) {
      this.quickSearch = quicksearch;
    },
  },
};
</script>



// WEBPACK FOOTER //
// main.vue?243f3618